import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Paper from "@mui/material/Paper";
import classes from "../../styles/DashboardView.module.css";
import { BestMonthCompare } from "../../utilities/dashboardAggregations";
import { numberWithCommas } from "../Oversigt";
import { YoYLegend, lightenMetricColor } from "./YoYLegend";
import { IndexBadge } from "./IndexBadge";

interface BestMonthsChartProps {
    data: BestMonthCompare[];
    currentYearLabel: string;
    prevYearLabel: string;
}

const COLOR = "#1976d2";
const REV_COLOR = "#2e7d32";
const PREV_COLOR = lightenMetricColor(COLOR);
const PREV_REV_COLOR = lightenMetricColor(REV_COLOR);

export function BestMonthsChart({ data, currentYearLabel, prevYearLabel }: BestMonthsChartProps) {
    if (!data || data.length === 0) {
        return (
            <Paper className={classes.chartCard} elevation={2}>
                <div className={classes.chartTitle}>Bedste måneder</div>
                <p>Ingen data</p>
            </Paper>
        );
    }

    return (
        <Paper className={classes.chartCard} elevation={2}>
            <div className={classes.chartHeader}>
                <h3 className={classes.chartTitle}>Bedste måneder <span className={classes.chartSubtitle}>· rangeret efter tilmeldinger</span></h3>
                <YoYLegend currentColor={COLOR} prevColor={PREV_COLOR} currentYearLabel={currentYearLabel} prevYearLabel={prevYearLabel} />
            </div>
            <ResponsiveContainer width="100%" height={520}>
                <BarChart data={data} layout="vertical" margin={{ left: 10 }} barCategoryGap="22%">
                    <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                    <XAxis type="number" tick={{ fontSize: 12 }} />
                    <YAxis type="category" dataKey="month" width={80} tick={{ fontSize: 12 }} interval={0} />
                    <Tooltip content={({ active, payload }: any) => {
                        if (!active || !payload || !payload[0]) return null;
                        const d: BestMonthCompare = payload[0].payload;
                        return (
                            <div style={{ background: "white", border: "1px solid #ccc", padding: 10, borderRadius: 4, minWidth: 200 }}>
                                <div style={{ fontWeight: 600, marginBottom: 6, textTransform: "capitalize" }}>{d.month}</div>
                                <div style={{ fontSize: 12, color: "#5f6368", marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>Tilmeldinger</div>
                                <div style={{ fontSize: 13, color: COLOR, fontWeight: 600 }}>{currentYearLabel}: {d.count}</div>
                                <div style={{ fontSize: 12, color: PREV_COLOR, fontWeight: 600 }}>{prevYearLabel}: {d.prevCount}</div>
                                <IndexBadge current={d.count} previous={d.prevCount} label="Indeks" />
                                <div style={{ fontSize: 12, color: "#5f6368", marginTop: 8, marginBottom: 2, textTransform: "uppercase", letterSpacing: 0.5 }}>Omsætning</div>
                                <div style={{ fontSize: 13, color: REV_COLOR, fontWeight: 600 }}>{currentYearLabel}: {numberWithCommas(d.revenue)} kr.</div>
                                <div style={{ fontSize: 12, color: PREV_REV_COLOR, fontWeight: 600 }}>{prevYearLabel}: {numberWithCommas(d.prevRevenue)} kr.</div>
                                <IndexBadge current={d.revenue} previous={d.prevRevenue} label="Indeks" />
                            </div>
                        );
                    }} />
                    <Bar dataKey="prevCount" name="previous" fill={PREV_COLOR} radius={[0, 3, 3, 0]} />
                    <Bar dataKey="count" name="current" fill={COLOR} radius={[0, 3, 3, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
}
